import { EntityBatchNode, type EntityBatchNodeProps } from "./EntityBatchNode";

export function ClientRecordBatchNode(props: Omit<EntityBatchNodeProps, "fallbackLabel">) {
  return <EntityBatchNode {...props} fallbackLabel="Client Record Batch" />;
}
